import { useState, MouseEvent, ReactNode } from 'react'
import { Menu, Button, ButtonProps, MenuProps } from '@mui/material'

type MenuButtonProps = {
  buttonName: string
  children?: ReactNode
  buttonProps?: Omit<ButtonProps, 'variant' | 'onClick'>
  menuProps?: Omit<MenuProps, 'onClose' | 'onClick' | 'open' | 'anchorEl'>
  variant?: 'text' | 'outlined' | 'contained'
}

function MenuButton({
  buttonName,
  children,
  buttonProps,
  menuProps,
  variant,
}: MenuButtonProps) {
  const [anchor, setAnchor] = useState<null | HTMLElement>(null)
  const isOpen = Boolean(anchor)
  function handleClick(event: MouseEvent<HTMLElement>) {
    setAnchor(event.currentTarget)
  }
  return (
    <>
      <Button variant={variant} onClick={handleClick} {...buttonProps}>
        {buttonName}
      </Button>
      <Menu
        anchorEl={anchor}
        open={isOpen}
        onClose={() => setAnchor(null)}
        onClick={() => setAnchor(null)}
        {...menuProps}
      >
        {children}
      </Menu>
    </>
  )
}

export default MenuButton
